export default __webpack_public_path__ + "static/media/gallerySub3.587f0343.png";